module.exports = __webpack_public_path__ + "static/media/serenedry-1.0c842d8a.png";